import { Box, Paper } from '@material-ui/core'

import StackedBarByMonth from './components/StackedBarByMonth'

const segments: { displayName: string; color: string; value: string }[] = [
  {
    displayName: 'Method Selected',
    color: '#FFB75F',
    value: 'notInitiated',
  },
  {
    displayName: 'In-Progress',
    color: '#32B4F2',
    value: 'initiated',
  },
  {
    displayName: 'Submitted',
    color: '#FF4090',
    value: 'submitted',
  },
]

type ApplicantChartData = {
  month: number
  year: number
  notInitiated: number
  initiated: number
  submitted: number
}

const ApplicantChart = ({ data }: { data: ApplicantChartData[] | undefined }) => {
  return (
    <Paper elevation={0}>
      {data === undefined ? (
        <Box style={{ height: 540 }}></Box>
      ) : (
        <StackedBarByMonth
          label="Applications"
          data={data}
          segments={segments}
        />
      )}
    </Paper>
  )
}

export default ApplicantChart
